// extracted by mini-css-extract-plugin
export default {"paper":"events_paper__ilX89","modal":"events_modal__BOqKB","root":"events_root__sXpTt","backdrop":"events_backdrop__O5ewh","cssRoot":"events_cssRoot__iYqXx"};